<div class="ignite-footer-container">
  <div id="text_footer" class="ignite-footer">
    <div>
      <a class="ignite-link" href="https://pearsonpte.com/privacy-policy/" rel="noopener" target="_blank" i18n>Privacy policy</a> |
      @if (showCookiesLink) {
        <span ><a id="ot-sdk-btn" class="ot-sdk-show-settings ignite-link" i18n>Cookies</a> | </span>
      }
      <a href="https://pearsonpte.com/contact-us/" class="ignite-link" rel="noopener" target="_blank" i18n>Contact us</a>
    </div>
    <div i18n>Copyright © 1996-{{ year }} Pearson. All rights reserved.</div>
  </div>
</div>
